<template>
  <div class="grid row">
    <div class="flex xs12">
      <va-card title="Value Edit" class="fill-height">
        <div>
          <div class="row">
            <div class="flex xs12">
              <va-tabs v-model="tabValue" style="width: 100%; min-width: 250px; margin-bottom: 25px;">
                <va-tab
                  v-for="title in tabTitles"
                  :key="title"
                >
                  {{title}}
                </va-tab>
              </va-tabs>
              <div class="flex xs12" v-if="tabValue === 0">
                <va-input
                  v-if="[
                    'aboutHonest',
                    'firstCounter',
                    'rowCounter',
                    'rowCounter2',
                    'titleCounter',
                    'firstCounter2',
                    'lastCounter',
                    'homeCounter',
                    'firstCounter3',
                    'audiCounter'
                  ].includes(this.$attrs.field)"
                  label="label *"
                  v-model="label"
                  :messages="['The recommended number of characters is 15']"
                  @input="delete errors.label"
                  :error="!!errors.label"
                  :error-messages="errors.label"
                />
                <va-input
                  v-if="[
                    'aboutTag',
                    'aboutValue',
                    'aboutBasis',
                    'aboutBasis2',
                    'aboutEnterprise',
                    'aboutHonest',
                    'aboutPrinsip',
                    'aboutPrinsip2',
                    'aboutPro',
                    'firstCounter',
                    'rowCounter',
                    'rowCounter2',
                    'titleCounter',
                    'cramb2',
                    'firstCounter2',
                    'lastCounter',
                    'product',
                    'homeCounter',
                    'firstCounter3',
                    'audiOdesa',
                    'lider',
                    'cramb'
                  ].includes(this.$attrs.field)"
                  label="description *"
                  v-model="description"
                  :messages="['The recommended number of characters is 15']"
                  @input="delete errors.description"
                  :error="!!errors.description"
                  :error-messages="errors.description"
                />
                <va-input
                  v-if="[
                    'firstCounter',
                    'rowCounter',
                    'rowCounter2',
                    'titleCounter',
                    'firstCounter2',
                    'lastCounter',
                    'product',
                    'homeCounter',
                    'firstCounter3'
                  ].includes(this.$attrs.field)"
                  label="additional_desc *"
                  v-model="additional_desc"
                  :messages="['The recommended number of characters is 15']"
                  @input="delete errors.additional_desc"
                  :error="!!errors.additional_desc"
                  :error-messages="errors.additional_desc"
                />
                <va-input
                  v-if="[''].includes(this.$attrs.field)"
                  label="text *"
                  v-model="text"
                  :messages="['The recommended number of characters is 15']"
                  @input="delete errors.text"
                  :error="!!errors.text"
                  :error-messages="errors.text"
                />
                <va-card
                  v-if="[
                    'aboutTag',
                    'aboutValue',
                    'aboutBasis',
                    'aboutBasis2',
                    'aboutEnterprise',
                    'aboutHonest',
                    'aboutPrinsip',
                    'aboutPrinsip2',
                    'aboutPro',
                    'firstCounter',
                    'rowCounter',
                    'rowCounter2',
                    'titleCounter',
                    'firstCounter2',
                    'lastCounter',
                    'product',
                    'audiOdesa',
                    'lider'
                  ].includes(this.$attrs.field)"
                  class="mb-3"
                  title="Image *">
                  <div v-if="imgExisting">
                    <a style="display: block;" target="_blank" :href="imgExisting">
                      <img style="max-width: 400px;" :src="imgExisting">
                    </a>
                    <div><va-button small color="danger" @click="imgExisting = deleteImage(imgId) ? '' : imgExisting">Видалити</va-button></div>
                  </div>
                  <span>Завантажити нове зображення</span>
                  <va-file-upload
                    type="gallery"
                    dropzone
                    v-model="img"
                    style="margin-bottom: 25px;"
                  />
                  <va-button @click="uploadImage(img[0])">Завантажити</va-button>
                </va-card>
                <va-button @click="submit()">Save</va-button>
              </div>
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  name: 'grid',
  data () {
    return {
      img: [],
      imgId: '',
      imgNew: '',
      imgExisting: '',

      lang: '',
      field: '',
      label: '',
      description: '',
      additional_desc: '',
      text: '',
      icon: '',

      errors: [],

      tabTitles: ['Main'],
      tabValue: 0,
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    uploadImage (file) {
      if (!file) {
        return
      }
      const formData = new FormData()
      formData.append('file', file)
      axios.post(`${process.env.VUE_APP_MS_DEV_API_URL}/${this.locale}/admin/media`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
        .then(response => {
          this.icon = response.data.patch
          this.imgNew = response.data.patch
          this.imgExisting = `${process.env.VUE_APP_MS_DEV_URL}/${this.imgNew}`
          this.imgId = response.data.id

          this.showToast('Successful upload')
        })
        .catch(error => {
          console.log(error)
          this.showToast('Error')
        })
    },
    async deleteImage (id) {
      return axios.delete(`${process.env.VUE_APP_MS_DEV_API_URL}/${this.locale}/admin/upload/${id}`)
        .then(() => {
          this.showToast('Successfully deleted')
        })
        .catch(() => {
          this.showToast('Error')
        })
    },
    submit () {
      const data = {
        lang: this.locale,
        field: this.$attrs.field,
        label: this.label,
        description: this.description,
        additional_desc: this.additional_desc,
        text: this.text,
        icon: this.icon,
      }
      if (this.$attrs.id) { // update
        axios.put(`${process.env.VUE_APP_MS_DEV_API_URL}/${this.locale}/admin/counter/${this.$attrs.id}`, data)
          .then(response => {
            this.showToast('Success')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }
            console.log(error)
            this.showToast('Error')
          })
      } else {
        axios.post(`${process.env.VUE_APP_MS_DEV_API_URL}/${this.locale}/admin/counter`, data)
          .then(response => {
            var aboutPage = ['aboutTag', 'aboutValue', 'aboutBasis', 'aboutBasis2', 'aboutEnterprise', 'aboutHonest', 'aboutPrinsip', 'aboutPrinsip2', 'aboutPro']
            if (aboutPage.includes(this.$attrs.field)) {
              this.$router.push({ name: 'ms-page-about' })
            } else if (this.$attrs.field === 'homeCounter') {
              this.$router.push({ name: 'ms-page-home' })
            } else {
              this.$router.push({ name: 'ms-companies' })
            }
            this.showToast('Success')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }
            console.log(error)
            this.showToast('Error')
          })
      }
    },
    fetch () {
      if (this.$attrs.id) {
        axios.get(`${process.env.VUE_APP_MS_DEV_API_URL}/${this.locale}/admin/counter/${this.$attrs.id}`)
          .then(response => {
            this.label = response.data.label
            this.description = response.data.description
            this.additional_desc = response.data.additional_desc
            this.text = response.data.text
            this.icon = response.data.icon
            this.imgExisting = response.data.icon
          })
          .catch(error => {
            console.log(error)
            this.showToast('Error')
          })
      }
    },
  },
  computed: {
    computedStyle () {
      return {
        backgroundColor: this.$themes.primary,
      }
    },
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
}
</script>

<style lang="scss">
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
  }
}

.va-file-upload-gallery-item {
  flex-basis: unset;
  max-width: 400px;
  width: unset;
}
</style>
